export function formSelect() {
  const formSelect = document.querySelectorAll('.form-select');
  if(formSelect.length) {
    for (let i = 0; i < formSelect.length; i++) {
      const select = formSelect[i];
      const view = select.querySelectorAll('.select-view');
      const hidden = select.querySelectorAll('.select-hidden');

      function changeSelect(el, index) {
        if(hidden.length){
          for (let i = 0; i < hidden.length; i++) {
            const _form = hidden[i];
            _form.options[index].selected = true;
          }
        }
        if(view.length){
          for (let i = 0; i < view.length; i++) {
            const label = view[i];
            label.innerHTML = el.value;
          }
        }
      }

      if(hidden.length){
        for (let i = 0; i < hidden.length; i++) {
          const el = hidden[i];
          for (let i = 0; i < el.options.length; i++) {
            const _el = el.options[i];
            if(_el.selected) {
              changeSelect(_el, i)
            }
          }
          el.addEventListener('change', function(e) {
            const index = el.selectedIndex;
            const selectedOption = el.options[index];
            changeSelect(selectedOption, index)
          });
        }
      }
    }
  }
}